import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BackOfficeService } from '../../../../../../app/services/backoffice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';
import { AdminService } from '../../../../../../app/services/admin.service';
import { SnackbarService } from '../../../../../../app/services/snackbar.service';
import { ForgotPasswordComponent } from '../../../../../components/forgot-password/forgot-password.component';
import { MobileNotificationFormComponent } from '../../back-office24-orders/mobile-notification-form/mobile-notification-form.component';
import { ConfirmDeleteComponent } from '../../../users/edit-user/confirm-delete/confirm-delete.component';


@Component({
  selector: 'app-back-office24-users-edit',
  standalone: false,
  templateUrl: './back-office24-users-edit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-office24-users-edit.component.css'
})
export class BackOffice24UsersEditComponent {
  @Output() saveChangesEvent = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();
  isLoading: boolean = false;
  editUserForm: UntypedFormGroup;
  enumEntries: any = [];
  languages = [{ value: 'svenska', viewValue: 'Svenska' }, { value: 'english', viewValue: 'English' }];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<BackOffice24UsersEditComponent>,
    private dialog: MatDialog,
    private backOfficeService: BackOfficeService,
    private snackBar: MatSnackBar,
    private translate: TranslocoService,
    public adminService: AdminService,
    public snackBarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const enumEntries = Object.entries(this.data?.orgType === "ParkingCompany" ? ParkingOrganizationMemberType : OrganizationMemberType)
      .filter(([key, value]) => typeof value === 'number')
      .map(([key, value]) => {
        const memberType = this.data?.organizationMemberTypes?.find((m: any) => m.id === value);
        return [key, value, memberType?.translation || key];
      });

    const userMembershipType: number = data.user?.memberType ?? 0;
    const membershipTypesControls = enumEntries.map(([key, value, translation]) => {
      if (key === 'None') {
        return this.fb.control(userMembershipType === 0);
      }
      return this.fb.control((userMembershipType & (value as number)) !== 0);
    });

    const isSmsVerified = data.user?.smsVerification?.toLowerCase() === 'true';
    this.editUserForm = this.fb.group({
      email: [{ value: data.user?.email || '', disabled: true }, [Validators.required, Validators.email]],
      firstname: [data.user?.firstname || '', [Validators.required]],
      lastname: [data.user?.lastname || '', [Validators.required]],
      mobile: [data.user?.mobile || ''],
      defaultLanguage: [data.user?.defaultLanguage || 'svenska', [Validators.required]],
      smsVerification: [isSmsVerified, [Validators.required]],
      memberTypes: this.fb.array(membershipTypesControls)
    });

    this.enumEntries = enumEntries;
    //
    //   const userMembershipType: number = data.user?.memberType ?? 0;
    //   this.organizationMemberTypes = this.data?.organizationMemberTypes;
    //   const currentOrg = this.data?.organization;
    //   const userMembershipRight = currentOrg?.memberShipRight || 0;
    //   const matchingMemberTypes = this.getMatchingMemberTypes(Number(userMembershipRight));
    //   this.memberShipTypes = matchingMemberTypes?.length > 0 ? matchingMemberTypes : this.organizationMemberTypes;
    //   const membershipTypesControls = this.memberShipTypes.map((memberType: any) => {
    //     if (memberType.value === 'None') {
    //       return this.fb.control(userMembershipType === 0);
    //     }
    //     return this.fb.control((userMembershipType & (memberType.id as number)) !== 0);
    //   });

    //   const isSmsVerified = data.user?.smsVerification?.toLowerCase() === 'true';
    //   this.editUserForm = this.fb.group({
    //     firstname: [data.user?.firstname || '', [Validators.required]],
    //     lastname: [data.user?.lastname || '', [Validators.required]],
    //     mobile: [data.user?.mobile || ''],
    //     defaultLanguage: [data.user?.defaultLanguage || 'svenska', [Validators.required]],
    //     smsVerification: [isSmsVerified, [Validators.required]],
    //     memberTypes: this.fb.array(membershipTypesControls)
    //   });
  }

  // getMatchingMemberTypes(membershipRight: number): any[] {
  //   return this.organizationMemberTypes.filter(memberType =>
  //     memberType.id > 0 && (membershipRight & memberType.id) === memberType.id
  //   );
  // }

  submitForm() {
    this.isLoading = true;
    const selectedTypes: number[] = this.editUserForm.value.memberTypes
      .map((checked: boolean, i: number) => checked ? (this.enumEntries[i][1] as number) : 0)
      .filter((v: number) => v !== 0);
    const memberType = selectedTypes.reduce((acc, curr) => acc | curr, 0);
    const payload = {
      userId: this.data.user?.userId,
      organizationId: this.data.targetOrganizationId,
      memberType,
      firstname: this.editUserForm.value.firstname,
      lastname: this.editUserForm.value.lastname,
      mobile: this.editUserForm.value.mobile,
      defaultLanguage: this.editUserForm.value.defaultLanguage,
      smsVerification: Boolean(this.editUserForm.value.smsVerification)
    };
    this.backOfficeService.createOrUpdateOrganizationMember(this.data.organizationId, payload).subscribe({
      next: (result) => {
        this.isLoading = false;
        const message = this.translate.translate('USER_MANAGEMENT.MEM_TYPE_UPDATION_SUCCESS');
        this.snackBar.open(message, 'OK', { duration: 3000, verticalPosition: 'top' });
        this.saveChangesEvent.emit({ data: result });
      },
      error: (error) => {
        this.isLoading = false;
        const message = this.translate.translate('USER_MANAGEMENT.MEM_TYPE_UPDATION_FAILED');
        console.error('Error updating membership type:', error);
        this.snackBar.open(message, 'OK', { duration: 3000, verticalPosition: 'top' });
      }
    })
    this.dialogRef.close();
  }

  editUser(payload: any) {
    this.adminService.updateUserDate(payload).subscribe(
      result => {
        console.warn('EDITED USER', payload);
        if (result) {
          this.snackBarService.openSnackBar('Ändringar sparade, vänligen ladda om sidan', 'OK');
          this.dialogRef.close();
        } else {
          this.snackBarService.openSnackBar('Något gick fel, vänligen kontrollera dina uppgifter', 'OK');
        }
      },
      error => {
        console.error(error);
        this.snackBarService.openSnackBar('Något gick fel', 'OK');
      }
    );
  }

  openForgotPassword(email: string) {
    this.dialog.open(ForgotPasswordComponent, {
      maxWidth: '95vw',
      maxHeight: '95vh',
      data: {
        email: email
      }
    });
  }

  openNotificationForm(userToken: string) {
    console.log(userToken);
    this.dialog.open(MobileNotificationFormComponent, {
      data: {
        userToken: userToken,
        title: '',
        message: '',
        payload: ''
      }
    });
  }

  openConfirmDelete() {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      width: '400px',
      data: {
        message: this.translate.translate('FORM.CONFIRM_DELETE'),
        buttonText: {
          ok: this.translate.translate('PARKIFLY.FORM.YES'),
          cancel: this.translate.translate('FORM.CANCEL')
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteUser();
      }
    });
  }

  deleteUser() {
    this.isLoading = true;
    const memberType = 1073741824; // for delete user
    const payload = {
      userId: this.data.user?.userId,
      organizationId: this.data.targetOrganizationId,
      memberType,
      firstname: this.editUserForm.value.firstname,
      lastname: this.editUserForm.value.lastname,
      mobile: this.editUserForm.value.mobile,
      defaultLanguage: this.editUserForm.value.defaultLanguage,
      smsVerification: Boolean(this.editUserForm.value.smsVerification)
    };
    this.backOfficeService.createOrUpdateOrganizationMember(this.data.organizationId, payload).subscribe({
      next: (result) => {
        this.isLoading = false;
        const message = this.translate.translate('USER_MANAGEMENT.DELETE_USER_SUCCESS');
        this.snackBar.open(message, 'OK', { duration: 3000, verticalPosition: 'top' });
        this.deleteEvent.emit({ data: result });
      },
      error: (error) => {
        this.isLoading = false;
        const message = this.translate.translate('USER_MANAGEMENT.DELETE_USER_FAILED');
        console.error('Error deleting user:', error);
        this.snackBar.open(message, 'OK', { duration: 3000, verticalPosition: 'top' });
      }
    })
    this.dialogRef.close();
  }
}

export enum ParkingOrganizationMemberType {
  Subscription = 2,
  VehicleAdministrator = 64,
  UserAdministrator = 128,
  Maintenance = 32
}

export enum OrganizationMemberType {
  // None = 0,
  ParkiflyAdministrator = 1,
  Subscription = 2,
  Maintenance = 32,
  // NotUsed3 = 4,
  // NotUsed4 = 8,
  // NotUsed5 = 16,
  // NotUsed6 = 32,
  VehicleAdministrator = 64,
  UserAdministrator = 128,
  ParkingOperator = 256,
  ParkingAdministrator = 512,
  ShuttleDriver = 1024,
  ParkingSurveillance = 2048,
  Driver = 4096,
  Staff = 8192,
  Dashboard = 16384,
}
